import React, { useContext, useEffect, useState } from 'react';
import context from '../../context';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { chunkArray, priceFormat } from '../../util';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { v1 as uuid } from 'uuid';
import Link from "../link";
import { Site, Surface, Parking, Bath, Rooms } from '../../icons';
import { gsap } from 'gsap';

const MainCont = styled.div`
  cursor: move;
`

const SliderCustom = styled(Slider)`
  padding-bottom: 1.5rem;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100px;
  position: absolute;
  top: .5rem;
  right: 4rem;
`
const ButtonBackCustom = styled(ButtonBack)`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 1.5rem;
  transition: 250ms ease;
  border:none;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: hsl(0, 0%, 43%);
  &:hover{
    color: hsl(0, 0%, 13%);
  }
`
const ButtonNextCustom = styled(ButtonNext)`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 1.5rem;
  transition: 250ms ease;
  border:none;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: hsl(0, 0%, 43%);
  &:hover{
    color: hsl(0, 0%, 13%);
  }
`
const Card = styled.div`
  width: 95%;
  transition: 250ms ease;
  &:hover{
    box-shadow: 0px 1px 1px rgba(0, 0, 0, .12),
              0px 2px 2px rgba(0, 0, 0, .12),
              0px 4px 4px rgba(0, 0, 0, .12),
              0px 8px 8px rgba(0, 0, 0, .12),
              0px 16px 16px rgba(0, 0, 0, .12);
  }
  @media(min-width: 768px){
    width: 100%;
  }
`
const Image = styled.div`
  width: 100%;
  padding-top: 60%;
  background-image: url("${props => props.src}");
  background-size: cover;
  background-position: center;
  position: relative;
`
const CharsList = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-family: 'Raleway', sans-serif !important;
  background-image: linear-gradient(135deg, rgba(210, 230, 245, 0.75), rgba(200, 225, 240, 0.75));
  opacity: 0;
  z-index: 5;
  transition: all 0.25s cubic-bezier(0.445, 0.05, 0.55, 0.95) 0s;
  padding: 1rem;
  margin: 0;

  span {
    margin-left: 0.5rem;
    color: #3C3C3C;
  }

  ${Card}:hover & {
    opacity: 1;
  }
`;
const CharItem = styled.li`
  display: flex;
  font-family: 'Raleway', sans-serif !important;
  align-items: center;
  padding-bottom: .3rem;
  color: black;
`
const TitleCont = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  min-height: 116px;
`
const Title = styled.p`
  margin: 0;
  color: #3C3C3C;
  font-family: 'Raleway', sans-serif !important;
  font-size: 1.5rem;
  font-weight: 500;
`
const Code = styled.p`
  margin: 0;
  font-size: .7rem;
  font-family: 'Raleway', sans-serif !important;
  min-width: 102.7px;
`

const getCategoryByCode = (title) => {
  if (typeof title !== 'string') return 'Categoría Desconocida';
  const categoryMapping = {
    '01': 'Casa', '02': 'Departamento', '03': 'Oficina',
    '04': 'Sitio', '05': 'Local', '08': 'Industrial',
    '09': 'Agrícola', '13': 'Agrícola', '10': 'Agrícola',
    '14': 'Parcela', '15': 'Estacionamiento', '16': 'Terreno',
    '17': 'Bodega', '30': 'Negocio/Patentes/Derechos de llave',
    '31': 'Residencial/Pieza', '32': 'Hotel/Apart',
    '33': 'Complejo Turístico', '34': 'Departamento Amoblado'
  };
  const digits = title.match(/^(\d{1,2})/);
  const foundCategory = digits ? digits[0].padStart(2, '0') : null;
  return categoryMapping[foundCategory] || 'Categoría Desconocida';
};

const Property = ({ mainImage, title, value, currency, code, ubication, characteristics, _id, operation }) => (
  <Link to={`/property?id=${_id}`}>
    <Card>
      <Image src={mainImage}>
        <CharsList>
          <CharItem>
            <Site />
            <span>{ubication.commune}</span>
          </CharItem>
          {characteristics.filter(char => (
            char.name === "Superficie total" ||
            char.name === "Superficie útil" ||
            char.name === "Habitaciones" ||
            char.name === "Baños" ||
            char.name === "Estacionamientos"
          )).map((char, index) => (
            <CharItem key={index}>
              {(char.name === "Superficie total" || char.name === "Superficie útil") && <Surface />}
              {char.name === "Habitaciones" && <Rooms />}
              {char.name === "Baños" && <Bath />}
              {char.name === "Estacionamientos" && <Parking />}
              <span>{char.name} {char.value} {(char.name === "Superficie total" || char.name === "Superficie útil") && "mt2"}</span>
            </CharItem>
          ))}
          <CharItem>{`${currency} ${currency === "UF" ? value : priceFormat(value)}`}</CharItem>
        </CharsList>
      </Image>
      <TitleCont>
        <Title>{getCategoryByCode(title)} {title.replace(/\d+/, '').trim()}</Title>
        <Code>{operation} - {code}</Code>
      </TitleCont>
    </Card>
  </Link>
);

export default () => {
  const [items, setItems] = useState([]);

  const fetchProperties = async () => {
    let all = [];
    for (let i = 5; i >= 0; i--) {
      const res = await fetch(`https://wsnzm.clasihome.com:3443/api/conv/properties?email=paolamunoz@nexxos.cl&status=PUBLICADA&limit=100&page=${i}`);
      const data = await res.json();
      all = [...all, ...data.properties.filter(p => p.exchange === "Sí")];
    }
    setItems(all);
  };

  useEffect(() => {
    fetchProperties();
    const interval = setInterval(() => {
      fetchProperties();
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const chunkedItemsDesktop = chunkArray(items, 2);
  const chunkedItemsTablet = chunkArray(items, 3);

  return (
    <MainCont id="wrapper">
      <CarouselProvider
        naturalSlideWidth={100}
        isIntrinsicHeight
        totalSlides={items.length}
        visibleSlides={1}
        className="d-md-none d-lg-none d-xl-none"
      >
        <SliderCustom>
          {items.map((item, index) => (
            <Slide key={item._id} index={index}>
              <Property {...item} />
            </Slide>
          ))}
        </SliderCustom>
      </CarouselProvider>

      <CarouselProvider
        naturalSlideWidth={100}
        isIntrinsicHeight
        totalSlides={chunkedItemsTablet.length}
        visibleSlides={1}
        className="d-none d-md-block d-lg-none"
      >
        <SliderCustom>
          {chunkedItemsTablet.map((group, index) => (
            <Slide key={uuid()} index={index}>
              <Row style={{ margin: "0 1rem" }}>
                {group.map(item => (
                  <Col xs={12} md={4} key={item._id}>
                    <Property {...item} />
                  </Col>
                ))}
              </Row>
            </Slide>
          ))}
        </SliderCustom>
        <ButtonBackCustom><ArrowLeftOutlined /></ButtonBackCustom>
        <ButtonNextCustom><ArrowRightOutlined /></ButtonNextCustom>
      </CarouselProvider>

      <CarouselProvider
        naturalSlideWidth={100}
        isIntrinsicHeight
        totalSlides={chunkedItemsDesktop.length}
        visibleSlides={1}
        className="d-none d-lg-block"
      >
        <SliderCustom>
          {chunkedItemsDesktop.map((group, index) => (
            <Slide key={uuid()} index={index}>
              <Row style={{ margin: "0 1rem" }}>
                {group.map(item => (
                  <Col xs={12} md={6} key={item._id}>
                    <Property {...item} />
                  </Col>
                ))}
              </Row>
            </Slide>
          ))}
        </SliderCustom>
        <ButtonContainer>
          <ButtonBackCustom><ArrowLeftOutlined /></ButtonBackCustom>
          <ButtonNextCustom><ArrowRightOutlined /></ButtonNextCustom>
        </ButtonContainer>
      </CarouselProvider>
    </MainCont>
  );
};